export default class JobseekerConditionalQuestionsTemp {
    constructor(
        public question_id: number = null,
        public question_name: string = null,
        public option_name : string = null,
        public option_id: number = null,
        public jobseeker_id: number = null,
        public provider?: string
    ){

    }
}